import React from "react";
import { css } from "styled-components";
import { Card } from "rebass";
import PropTypes from "prop-types";
import theme from "../../../theme";
import imgsrc from "../../images/plx2021.jpg";

export const Background = ({ children }) => (
  <Card
    backgroundImage={[`url(${imgsrc})`]}
    backgroundSize="contain"
    backgroundRepeat="no-repeat"
    css={css`
      background-position: center center;
      position: fixed;
      bottom: 96px;
      left: 12vw;
      width: 30vh;
      height: 48vh;
      content: "";
      @media (min-width: 1024px) {
        top: 0;
        bottom: auto;
        left: 0;
        width: ${theme.posterW.large};
        height: 100vh;
      }
    `}
  >
    {children}
  </Card>
);

Background.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
